import { useOverrideState } from './useOverrideState'

interface BreadcrumbState {
  mode: 'view' | 'add'
  addName?: string
}

export const breadcrumbState = useOverrideState<BreadcrumbState>({
  mode: 'view',
})
